import { createSlice } from '@reduxjs/toolkit';

import { categories } from 'config/categories';

export const categoriesSlice = createSlice({
    name: 'categories',
    initialState: {
        categories: categories,
        activeCategory: "all",
    },
    reducers: {
        setActiveCategory(state, action) {
            state.activeCategory = action.payload;
        },
    },
});

export const categoriesSelector = (state) => state.categories;
export const { setActiveCategory } = categoriesSlice.actions;
export default categoriesSlice.reducer;